import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TiimePipesModule } from 'tiime-expert-utils';
import { TiimeContainerModule, TiimeDialogModule, TiimePaginatorModule, TiimeTableModule } from 'tiime-material';

import { EntityHistoryTableComponent } from '@modules/shared/tables/entity-history-table/entity-history-table.component';
import { EntityHistoryDialogComponent } from '@shared-dialogs/entity-history-dialog/entity-history-dialog.component';

@NgModule({
  declarations: [EntityHistoryDialogComponent],
  imports: [
    TiimeDialogModule,
    CommonModule,
    EntityHistoryTableComponent,
    TiimeContainerModule,
    TiimePaginatorModule,
    TiimePipesModule,
    TiimeTableModule
  ]
})
export class EntityHistoryDialogModule {}
